export const SHIPPED_ORDER_DATA = 'SHIPPED_ORDER_DATA';
export const SHIPPED_DELETE_ORDER_DATA = 'SHIPPED_DELETE_ORDER_DATA, ';
